import { ComponentType, ReactNode } from 'react';
import { Button } from '../Button';
import { Icons } from '../Icons';
import { NightSwitch } from '../NightSwitch';

import styles from './Header.module.scss';

interface HeaderProps {
  rightMenu: ReactNode;
  onMenuClick?: () => void;
  onLogoClick?: () => void;
  logo: ComponentType;
}

export function Header({
  onMenuClick,
  onLogoClick,
  rightMenu,
  logo: Logo
}: HeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.section}>
        <Button variant="phantom" onClick={onMenuClick}>
          <Icons.Menu />
        </Button>
        <Button variant="phantom" onClick={onLogoClick}>
          <Logo />
        </Button>
      </div>
      <div className={styles.section}>
        {rightMenu}
        <NightSwitch />
      </div>
    </header>
  );
}
